module.exports = __webpack_public_path__ + "img/shape_parallelogram.a817c091.png";